"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function jsonStringify(options) {
    if (!BigInt) {
        console.warn(`BigInt Not Support.
       You could use \`bignumber.js\` and specify \`options.isBigInt\` for purpose of judging if value is a big int.`);
    }
    let _options = {
        isBigInt: value => typeof value === 'bigint',
    };
    if (options && typeof options.isBigInt === 'function') {
        _options.isBigInt = options.isBigInt;
    }
    function getRandomStr(len) {
        if (len) {
            return getRandomStr() + getRandomStr(len - 1);
        }
        return (100 * Math.random()).toString(36).replace(/\./g, '');
    }
    return function stringify(obj) {
        const guard = getRandomStr(2);
        const stringified = JSON.stringify(obj, (key, value) => (_options.isBigInt(value) ? `${guard}${value.toString()}${guard}` : value));
        return stringified.replace(new RegExp(`"${guard}|${guard}"`, 'g'), '');
    };
}
exports.default = jsonStringify;
//# sourceMappingURL=stringify.js.map